<template>
    <div v-if="isFirst===1" class="contents">
        <div class="operateGuide">
            <!-- <el-carousel indicator-position="outside" :interval="5000"  arrow="always"> -->
            <!-- 手动切换轮播图 -->
            <el-carousel indicator-position="none" :autoplay="false"  arrow="always" trigger="click" ref="carouselActiveGuide" :loop="false">
                <el-carousel-item name="first">
                    <div class="cardTab">
                        <!-- <h4>step1</h4> -->
                        <img src="../../../images/guide_01.gif" alt="">
                    </div>
                </el-carousel-item>
                <el-carousel-item name="second">
                    <div class="cardTab">
                        <img src="../../../images/guide_02.gif" alt="">
                    </div>
                </el-carousel-item>
                <el-carousel-item name="third">
                    <div class="cardTab">
                        <img src="../../../images/guide_03.gif" alt="">
                    </div>
                </el-carousel-item>
                <el-carousel-item name="fourth">
                    <div class="guideEnd">
                        <p class="headPic"><img src="../../../images/pic.png" style="width:120px; height:120px;"></p>
                        <!-- <p class="user">Allie(MS)</p> -->
                        <p class="user" v-if="sales_adminuser!=''">{{sales_adminuser.name_en}} (<span v-if="sales_adminuser.sex==='0'">Ms</span><span v-else-if="sales_adminuser.sex==='1'">Mr</span>)</p>
                        <p class="user" v-else>{{manager_adminuser.name_en}} (<span v-if="manager_adminuser.sex==='0'">Ms</span><span v-else-if="manager_adminuser.sex==='1'">Mr</span>)</p>
                        <p v-if="sales_adminuser!=''">{{sales_adminuser.email}}</p>
                        <p v-else>{{manager_adminuser.email}}</p>

                        <p class="text">Welcome to the CFF warehousing service, We have assigned you a dedicated account manager</p>
                        <p class="text">If you have any questions about usage, including pricing, operations, recharge, discounts, etc...</p>
                        <p class="text">please consult your account manager.</p>
                        <p class="buttons" @click="setStep(2)">Start CFF</p>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
    <div v-else-if="isFirst===2" class="contents">
        <!-- 任务未完成 -->
        <!-- 哪些完成 点亮哪些 -->
        <template>
            <div>
                <p style="line-height:30px; margin-bottom:30px; color:#f08b22; font-weight:bold;" >Your sku has not been placed in the library and cannot be shipped  automatically. Please follow the process below or contact your account manager for support</p>
                <el-steps finish-status="success" :align-center="true">
                    <el-step title="Synchronize sku to CFF" v-bind:class="{isActive:step1}">
                        <template slot="icon">
                            <!-- 成功状态的按钮要单独处理，不能用element自带的，否则事件加不上 -->
                            <i v-if="step1==='No'" class="iconfont icon-gantanhao-yuankuang" style="font-size:30px; cursor:pointer;" @click="setActiveItem('first')"></i>
                            <i v-else-if="step1==='Yes'" class="iconfont icon-duihao2" style="font-size:28px; cursor:pointer; color:rgb(137, 137, 186)" @click="setActiveItem('first')"></i>
                        </template>
                    </el-step>
                    <el-step title="Precharge" v-bind:class="{isActive:step2}">
                        <template slot="icon">
                            <i v-if="step2==='No'" class="iconfont icon-gantanhao-yuankuang" style="font-size:30px; cursor:pointer" @click="setActiveItem('second')"></i>
                            <i v-else-if="step2==='Yes'" class="iconfont icon-duihao2" style="font-size:28px; cursor:pointer; color:rgb(137, 137, 186)" @click="setActiveItem('second')"></i>
                        </template>
                    </el-step>
                    <el-step title="Create an ASN order" v-bind:class="{isActive:step3}">
                        <template slot="icon">
                            <i v-if="step3==='No'" class="iconfont icon-gantanhao-yuankuang" style="font-size:30px; cursor:pointer;" @click="setActiveItem('third')"></i>
                            <i v-else-if="step3==='Yes'" class="iconfont icon-duihao2" style="font-size:28px; cursor:pointer; color:rgb(137, 137, 186)" @click="setActiveItem('third')"></i>
                        </template>
                    </el-step>
                    <el-step title="Transporting products to the warehouse" v-bind:class="{isActive:step4}">
                        <template slot="icon">
                            <i v-if="step4==='No'" class="iconfont icon-gantanhao-yuankuang" style="font-size:30px; cursor:pointer;" @click="setActiveItem('fourth')"></i>
                            <i v-else-if="step4==='Yes'" class="iconfont icon-duihao2" style="font-size:28px; cursor:pointer; color:rgb(137, 137, 186)" @click="setActiveItem('fourth')"></i>
                        </template>
                    </el-step>
                    <el-step title="Set shipping rules" v-bind:class="{isActive:step5}" >
                        <template slot="icon">
                            <i v-if="step5==='No'" class="iconfont icon-gantanhao-yuankuang" style="font-size:30px; cursor:pointer;" @click="setActiveItem('fifth')"></i>
                            <i v-else-if="step5==='Yes'" class="iconfont icon-duihao2" style="font-size:28px; cursor:pointer; color:rgb(137, 137, 186)" @click="setActiveItem('fifth')"></i>
                        </template>
                    </el-step>
                </el-steps>
            </div>
        </template>

        <template>
            <div class="operateGuide">
                <!-- <el-carousel indicator-position="outside" :interval="5000"  arrow="always"> -->
                <!-- 手动切换轮播图 -->
                <el-carousel indicator-position="outside" :autoplay="false"  arrow="always" trigger="click" ref="carouselActive">
                    <el-carousel-item name="first">
                        <div class="cardTab">
                            <!-- <h4>step1</h4> -->
                            <img src="../../../images/1.png" alt="">
                        </div>
                    </el-carousel-item>
                    <el-carousel-item name="second">
                        <div class="cardTab">
                            <img src="../../../images/2.png" alt="">
                        </div>
                    </el-carousel-item>
                    <el-carousel-item name="third">
                        <div class="cardTab">
                            <img src="../../../images/3.png" alt="">
                        </div>
                    </el-carousel-item>
                    <el-carousel-item name="fourth">
                        <div class="cardTab">
                            <img src="../../../images/04.gif" alt="">
                        </div>
                    </el-carousel-item>
                    <el-carousel-item name="fifth">
                        <div class="cardTab">
                            <img src="../../../images/5.png" alt="">
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </template>
    </div>
    <!-- 五步全部完成 -->
    <div v-else-if="isFirst===3" class="contents">
        <template>
            <div>
                <el-steps finish-status="success" :align-center="true" :active="5">
                    <el-step title="Synchronize sku to CFF"></el-step>
                    <el-step title="Precharge"></el-step>
                    <el-step title="Create an ASN order"></el-step>
                    <el-step title="Transporting products to the warehouse"></el-step>
                    <el-step title="Set shipping rules"></el-step>
                </el-steps>
            </div>
            <div class="hasFinish">
                <i class="iconfont icon-52" style="font-size:100px; color:#91c0ea; display:inline-block; padding-bottom: 12px;" ></i>
                <p>Great! You have completed the pre-preparation, you can already open the CFF automatic delivery service!</p>
                <p>
                    <span>Orders from </span>
                    <span class="time" style="position:relative">
                        {{startTime}}
                        <b style="width:100%;height:20px;line-height:20px;position:absolute;top:-2px;left:0;opacity:0;overflow:hidden;">
                            <el-date-picker
                            style="height:20px;"
                            v-model="startTime_pop"
                            type="date"
                            format="yyyy-MM-dd"
                            placeholder="Choose the starting time">
                            </el-date-picker>
                        </b>
                    </span>
                </p>
                <div class="buttons" @click="automaticDevilary()">Start automatic delivery</div>
            </div>
        </template>
    </div>
    <div v-else-if="isFirst===4" class="contents">
        <!-- 提示 -->
        <div class="notice border" v-bind:class="{'myMove':!hasNotice}">
            <template>
                <vue-seamless :data="noticeList1" :class-option="optionSingleHeightTime" class="seamless-warp noticeTab floatL">
                    <ul class="item">
                        <li v-for="(notice,index) in noticeList1" :key="index" class="clearfix">
                            <span style="width:55px">Notice：</span><a :href="notice.link" target="_blank" class="floatL clearfix" style="width:calc(100% - 65px)"><span :title="notice.title" class="titles" v-text="notice.title"></span><span class="date" style="width:72px" v-text="notice.time"></span></a>
                            <!-- <span>Notice：</span><a :href="notice.link" target="_blank"><span class="title" v-text="notice.title"></span><span class="date" v-text="notice.time"></span></a> -->
                        </li>
                    </ul>
                </vue-seamless>
            </template>
            <template>
                <vue-seamless :data="noticeList2" :class-option="optionSingleHeightTime" class="seamless-warp noticeTab floatR">
                    <ul class="item">
                        <li v-for="(notice,index) in noticeList2" :key="index" class="clearfix">
                            <a :href="notice.link" target="_blank" class="floatR clearfix" style="width:calc(100% - 65px)"><span class="date" style="width:72px" v-text="notice.time"></span><span :title="notice.title" class="titles" v-text="notice.title"></span></a><span style="width:55px">Notice：</span>
                        </li>
                    </ul>
                </vue-seamless>
            </template>
            <p class="loading" v-show="!loaded"><i class="el-icon-loading"></i></p>
            <p class="more"><a href="https://blog.sendfromchina.com/blog/category/sfc-announcement/" target="_black">more >></a></p>
        </div>
        <!-- 余额不足警告 -->
        <div class="warnTab border clearfix" v-show="arrears">
            <p class="floatL redColor">
                <i class="el-icon-warning"></i>
                Your account balance is not enough, please recharge in time to avoid delays in delivery!
            </p>
            <p class="floatR">
                <a class="button" @click="reCharge()">Recharge</a>
            </p>
        </div>
        <!--  -->
        <div class="msgTab border">
            <div class="statusTab clearfix">
                <div class="floatL">
                    <span>The automatic delivery service is being executed. The next delivery order time is: </span>
                    <span class="basicColor">{{shopMsg.time}}</span>
                </div>
                <div class="floatR">
                    <a class="button" v-if="shopMsg.eut_status=='0'" @click="toggleStatus('1')">Service continued</a>
                    <a class="button" v-else-if="shopMsg.eut_status=='1'" @click="toggleStatus('0')">Service paused</a>
                </div>
            </div>
            <div class="statusTab storage clearfix">
                <div class="floatL">
                    <span>Warehosing service basic project: </span>
                    <span class="basicColor">{{storageData.billing_date}} ~ {{storageData.expired}}</span>
                </div>
                <div class="floatR">
                    <!-- <router-link to="/Finance/myPrice">
                        <a class="button" @click="toMyPrice()">Price List</a>
                    </router-link> -->
                    <a class="button" @click="toMyPrice()">Price List</a>
                    <a class="button" @click="toMyBill()">More details</a>
                    <!-- <router-link to="/Finance/flowBill">
                        <a class="button" @click="toMyBill()">More details</a>
                    </router-link> -->
                </div>
            </div>
            <el-row :gutter="40" class="Tabs">
                <el-col :span="8">
                    <div class="grid-content">
                        <p class="tip">TAKE UP SPACE
                            <el-tooltip class="item" effect="dark" placement="bottom">
                                <div slot="content">
                                    Expense incurred on the mounth
                                </div>
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </p>
                        <div class="field">
                            <p class="clearfix">
                                <span class="floatL">Incurred</span>
                                <span class="floatR">{{storageData.pallet_used}}</span>
                            </p>
                            <p class="clearfix">
                                <span class="floatL">Cost</span>
                                <span class="floatR">{{storageData.pallet_total}}</span>
                            </p>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <p class="tip">SKU
                            <el-tooltip class="item" effect="dark" placement="bottom">
                                <div slot="content">
                                    Expense incurred on the mounth
                                </div>
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </p>
                        <div class="field">
                            <p class="clearfix">
                                <span class="floatL">Incurred</span>
                                <span class="floatR">{{storageData.sku_used}}</span>
                            </p>
                            <p class="clearfix">
                                <span class="floatL">Cost</span>
                                <span class="floatR">{{storageData.sku_total}}</span>
                            </p>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <p class="tip">item
                            <el-tooltip class="item" effect="dark" placement="bottom">
                                <div slot="content">
                                    Expense incurred on the mounth
                                </div>
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </p>
                        <div class="field">
                            <p class="clearfix">
                                <span class="floatL">Incurred</span>
                                <span class="floatR">{{storageData.item_used}}</span>
                            </p>
                            <p class="clearfix">
                                <span class="floatL">Cost</span>
                                <span class="floatR">{{storageData.item_total}}</span>
                            </p>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="80" class="forTwo">
                <el-col :span="12">
                    <div class="listPanel">
                        <span>Product Overview: </span>
                        <span class="basicColor">{{storageData.billing_date}} ~ {{storageData.expired}}</span>
                    </div>
                    <ul class="listTab">
                        <li class="clearfix">
                            <span class="floatL">Total number of SKUs</span>
                            <span class="floatR">{{productData.total_num}}</span>
                        </li>
                        <li class="clearfix">
                            <span class="floatL">Synchronized SKU</span>
                            <span class="floatR">{{productData.tb_num}}</span>
                        </li>
                        <li class="clearfix">
                            <span class="floatL">Inbound SKU</span>
                            <span class="floatR">{{productData.rk_num}}</span>
                        </li>
                        <li class="clearfix">
                            <span class="floatL">Out of stock</span>
                            <span class="floatR">{{productData.qh_num}}</span>
                        </li>
                    </ul>
                </el-col>
                <el-col :span='12'>
                    <div class="listPanel">
                        <span>Order Overview: </span>
                        <span class="basicColor">{{storageData.billing_date}} ~ {{storageData.expired}}</span>
                    </div>
                    <ul class="listTab">
                        <li class="clearfix">
                            <span class="floatL">Automatic delivery success</span>
                            <span class="floatR">{{orderData.hand_num}}</span>
                        </li>
                        <li class="clearfix">
                            <span class="floatL">Shipped</span>
                            <span class="floatR">{{orderData.send_num}}</span>
                        </li>
                        <li class="clearfix">
                            <span class="floatL">Pending order</span>
                            <span class="floatR">{{orderData.dcl_num}}</span>
                        </li>
                        <li class="clearfix">
                            <span class="floatL">Total shipping cost</span>
                            <span class="floatR">{{shipfee}}</span>
                        </li>
                    </ul>
                </el-col>
            </el-row>

            <el-row :gutter="80" class="forTwo">
                <el-col :span="12">
                    <div class="listPanel">Your account manager</div>
                    <div class="picPanel">
                        <p class="pic"><img src="../../menu/img/SFC-logo.png" style="width:120px; height:120px;"></p>
                        <p>{{sales_adminuser.name_en}} (<span v-if="sales_adminuser.sex==='0'">Ms</span><span v-else-if="sales_adminuser.sex==='1'">Mr</span>)</p>
                        <p>{{sales_adminuser.email}}</p>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="listPanel">Customer service manager</div>
                    <div class="picPanel">
                        <p class="pic"><img src="../../menu/img/SFC-logo.png" style="width:120px; height:120px;"></p>
                        <p>{{service_adminuser.name_en}} (<span v-if="service_adminuser.sex==='0'">Ms</span><span v-else-if="service_adminuser.sex==='1'">Mr</span>)</p>
                        <p>{{service_adminuser.email}}</p>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import { getUserStatus, getChartFree, getPlanUsage, kindOfSku, kindOfOrder, getMaster, sendOrderTime, changeStatus, getNotice, getShopifyStep, updateShopifyStep } from '../../views/api/home'
import { getKey, setKey, removeKey } from '../../utils/sessionStorage'
import { UrlSearch } from '../../utils/UrlSearch' // 店铺名称从URL截取
import vueSeamless from 'vue-seamless-scroll'
import store from '@/store'

import { getToken } from '../../utils/auth'

export default{
  components: {
    vueSeamless
  },
  data () {
    return {
      // customer_id: '',
      warehouse_id: '',
      account: '', // 店铺名称
      isFirst: 0,
      active: 0,
      guide1: true, // 前置引导三步(不可跨越点击)
      guide2: false,
      guide3: false,
      guide4: false,

      hasOver: true, // 五步执行完成
      timeVisible: false, // 选择时间
      startTime: '2019/04/03',
      startTime_pop: '',
      step1: 'No',
      step2: 'No',
      step3: 'No',
      step4: 'No',
      step5: 'No',
      noticeList1: [
        // {
        //     title:'复联4票房过5亿',
        //     time:'2019-04-22'
        // },{
        //     title:'大连一化工厂爆炸',
        //     time:'2019-04-22'
        // },{
        //     title:'斯里兰卡突发恐怖袭击',
        //     time:'2019-04-21'
        // },{
        //     title:'龙池山火已扑灭',
        //     time:'2019-04-21'
        // },{
        //     title:'IG斩获LPL冠军奖杯',
        //     time:'2019-04-21'
        // }
      ],
      noticeList2: [
        // {
        //     title:'刘强东案关键证人',
        //     time:'2019-04-22'
        // },{
        //     title:'外卖哥撞人遭索赔',
        //     time:'2019-04-22'
        // },{
        //     title:'地球的经济中心',
        //     time:'2019-04-21'
        // },{
        //     title:'张丹峰回应出轨',
        //     time:'2019-04-21'
        // },{
        //     title:'特斯拉回应自燃',
        //     time:'2019-04-21'
        // }
      ],
      loaded: true,
      hasNotice: true,
      balance: '', // 账户余额
      shipfee: '', // 运费总计
      arrears: false, // 余额不足
      // lastTime:'2019/04/21 12:15',
      nowStatus: '0', // 0启动状态 1暂停状态
      // billing_date:'2019-03-12 12:14', // 开始时间
      // expired:'2019-04-21 15:21', // 结束时间
      shopMsg: { // 店铺信息
        eut_id: '', // 店铺ID
        eut_status: '', // 店铺服务状态 0-关闭  1-开启
        time: '' // 下次交寄时间
      },
      storageData: { // 仓储服务数据
        pallet_used: '',
        pallet_qty: '',
        sku_used: '',
        sku_qty: '',
        item_used: '',
        item_qty: '',
        billing_date: '',
        expired: ''
      },
      productData: { // 产品概况
        total_num: '12',
        tb_num: '2',
        rk_num: '4',
        qh_num: '6'
      },
      orderData: { // 订单概况
        hand_num: '234',
        send_num: '23',
        dcl_num: '24'
        // total_cost:'￥5621'
      },
      sales_adminuser: '',
      service_adminuser: '',
      manager_adminuser: ''
    }
  },
  computed: {
    optionSingleHeightTime () {
      return {
        singleHeight: 38, // 单行停顿
        waitTime: 5000 // 停顿时间
      }
    },
    customer_id () {
      return store.getters.user || store.getters.shopTokenuser.customer_id
    }
  },
  beforeCreate () {
    const userparam = UrlSearch()
    if (userparam.shop) {
      console.log(userparam.shop)
      let url = userparam.shop
      let index = url.indexOf('.')
      this.account = url.substring(0, index)
    }
  },
  created () {
    if (store.getters.shopTokenuser && store.getters.token) {
      let user = store.getters.shopTokenuser
      console.log('shopTokenuser', user)
      this.customer_id = user.customer_id
      this.warehouse_id = user.warehouse_id
      getMaster({customer_id: this.customer_id}).then(response => {
        console.log(response)
        if (response.data.ask === 1) {
          this.sales_adminuser = response.data.data.sales_adminuser
          this.service_adminuser = response.data.data.service_adminuser
          this.manager_adminuser = response.data.data.manager_adminuser
        }
      }).catch(err => {
        console.log(err)
      })
    }
    const userparam = store.getters.shopTokenuserparam
    if (userparam.shop) {
      console.log(userparam.shop)
      let url = userparam.shop
      let index = url.indexOf('.')
      this.account = url.substring(0, index)
    }
    // 生命周期(先获取用户状态) 状态2-未完成， 当五个状态标记都为true时，状态变为3；点击设置自动交寄时间时，若后端返回成功，择状态置为4，
    // 接口  -  获取用户状态 、 设置用户状态 、 设置交寄开始时间
    // if (store.getters.token) {
    //   alert(store.getters.token)
    //   this.getStep()
    // }
    const interval = setInterval(() => {
      if (store.getters.token) {
        clearInterval(interval)
        this.getStep()
      }
    }, 500)
    this.startTime = this.dataTime(new Date())

    // this.start()
  },
  methods: {

    start () {
      // 余额-运费总计 get-chart-fee
      getChartFree({customer_id: this.customer_id}).then(response => {
        console.log(response)
        // 存储余额
        // setKey('balance','￥9568.6');
        removeKey('balance')
        if (response.data.ask === 1 && response.data.data) {
          this.balance = response.data.data.balance
          this.shipfee = response.data.data.shipfee
          if (this.balance > 0) {
            this.arrears = false
          } else {
            this.arrears = true
          }
          // 更新余额
          // store.dispatch('Recharge',true);
          store.dispatch('updateBalance', this.balance)
          // setKey('balance',this.balance);
        }
      }).catch(err => {
        console.log(err)
      })
      //  仓储服务数据 get-plan-usage
      getPlanUsage({customer_id: this.customer_id, warehouse_id: this.warehouse_id}).then(response => {
        console.log(response)
        if (response.data.ask === 1 && response.data.data) {
          this.storageData = response.data.data
        }
      }).catch(err => {
        console.log(err)
      })

      // 产品概况数据 kind-of-sku
      kindOfSku({customer_id: this.customer_id, warehouse_id: this.warehouse_id}).then(response => {
        console.log(response)
        if (response.data.ask === 1 && response.data.data) {
          this.productData = response.data.data
        }
      }).catch(err => {
        console.log(err)
      })

      // 订单概况数据 kind-of-order
      kindOfOrder({customer_id: this.customer_id, warehouse_id: this.warehouse_id}).then(response => {
        console.log(response)
        if (response.data.ask === 1 && response.data.data) {
          this.orderData = response.data.data
        }
      }).catch(err => {
        console.log(err)
      })

      // 下次交寄订单时间-当前店铺状态-店铺状态主键
      sendOrderTime({customer_id: this.customer_id, account: this.account}).then(response => {
        console.log(response)
        if (response.data.ask === 1 && response.data.data) {
          this.shopMsg = response.data.data
        }
      }).catch(err => {
        console.log(err)
      })

      // 客户客服信息 get-manager
      getMaster({customer_id: this.customer_id}).then(response => {
        console.log(response)
        if (response.data.ask === 1) {
          this.sales_adminuser = response.data.data.sales_adminuser
          this.service_adminuser = response.data.data.service_adminuser
        }
      }).catch(err => {
        console.log(err)
      })
      this.loaded = false
      this.noticeList1 = []
      this.noticeList2 = []

      getNotice().then(response => { // 公告信息
        console.log(response)
        let _this = this
        _this.loaded = true
        if (response.status === 200 && response.data) {
          // 左右两个公告数据按奇偶分割，
          if (response.data.length > 0) {
            _this.hasNotice = true
          } else {
            _this.hasNotice = false
          }
          response.data.forEach((notice, index) => {
            let json = {
              title: notice.title.rendered,
              time: _this.dataTime(notice.date),
              link: notice.link
            }
            if (index % 2 === 0) {
              _this.noticeList1.push(json)
            } else if (index % 2 === 1) {
              _this.noticeList2.push(json)
            }
          })
        } else {
          this.$message({
            message: 'Failed to obtain bulletin information',
            type: 'warning'
          })
          _this.hasNotice = false
        }
      }).catch(err => {
        console.log(err)
        this.hasNotice = false
      })
    },
    // 手动切换轮播
    setActiveItem (name) {
      this.$refs.carouselActive.setActiveItem(name)
    },
    // 状态切换
    toggleStatus (status) {
      let msg = 'Identify Open Services?'
      let rspOk = 'Service has been opened！'
      let rspErr = 'Service Startup Failure！'
      if (status === '0') {
        msg = 'Determine suspension of service?'
        rspOk = 'Service suspended！'
        rspErr = 'Failure to suspend service！'
      }
      const _this = this
      this.$confirm(msg, {
        confirmButtonText: 'Sure',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        changeStatus({customer_id: this.customer_id, account: this.account, eut_id: _this.shopMsg.eut_id, eut_status: status}).then(response => {
          if (response.data.ask === 1) {
            _this.shopMsg.eut_status = status
            this.$message({
              message: rspOk,
              type: 'success'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          message: 'Cancelled',
          type: 'info'
        })
      })
    },
    toMyPrice () {
      store.dispatch('updatemenu', '/Finance')
      this.$router.push({
        path: '/Finance/myPrice'
      })
    },
    toMyBill () {
      store.dispatch('updatemenu', '/Finance')
      this.$router.push({
        path: '/Finance/flowBill'
      })
    },
    // 时间格式转换
    dataTime (time) {
      const date = new Date(time)
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (parseInt(date.getMonth() + 1)) : date.getMonth() + 1
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      const newTime = Y + '-' + M + '-' + D + ' ' + H + ':' + m + ':' + s
      // console.log('转换时间',Y+'-'+M+'-'+D+' '+H+':'+m+':'+s)
      return newTime
    },
    // 充值触发更新state
    reCharge () {
      store.dispatch('Recharge', true)
      console.log('store', store)
    },
    // 选中时间
    sureTime () {
      this.startTime = this.dataTime(this.startTime_pop)
      this.timeVisible = false
    },
    // 时间格式转换
    dataTime (time) {
      const date = new Date(time)
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (parseInt(date.getMonth() + 1)) : date.getMonth() + 1
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      const newTime = Y + '/' + M + '/' + D
      return newTime
    },

    // 设置自动交寄时间
    automaticDevilary () {
      this.$confirm('Determine to open automatic delivery service?', {
        confirmButtonText: 'sure',
        cancelButtonText: 'cancel'
      }).then(() => {
        // this.isFirst=4;
        this.setStep(4)
      }).catch(() => {

      })
    },
    // 获取步骤
    getStep () {
      const params = {
        customer_id: this.customer_id,
        warehouse_id: this.warehouse_id,
        account_name: this.account
      }
      const _this = this
      getShopifyStep(params).then(response => {
        console.log(response)
        if (response.data.ask === 1) {
          // 状态二要单独处理，当五个状态全OK要将状态改为3
          if (response.data.step === 2 && response.data.data) {
            _this.step1 = response.data.data.step1
            _this.step2 = response.data.data.step2
            _this.step3 = response.data.data.step3
            _this.step4 = response.data.data.step4
            _this.step5 = response.data.data.step5
            if (_this.step1 === 'Yes' && _this.step2 === 'Yes' && _this.step3 === 'Yes' && _this.step4 === 'Yes' && _this.step5 === 'Yes') {
              _this.setStep(3)
            } else {
              _this.isFirst = response.data.step
            }
          } else {
            this.isFirst = response.data.step
            if (response.data.step === 4) {
              this.start()
            }
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 设置步骤
    setStep (num) {
      let params = {
        customer_id: this.customer_id,
        warehouse_id: this.warehouse_id,
        account_name: this.account,
        step: num
      }
      if (num === 4) {
        params.date = this.dataTime(this.startTime_pop)
      }
      updateShopifyStep(params).then(response => {
        console.log(response)
        if (response.data.ask === 1) {
          // this.isFirst = num;
          this.getStep()
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  // 监控交寄时间改变时，处理日期格式
  watch: {
    'startTime_pop': function () {
      this.sureTime()
    }
  }
}
</script>
<style>
    .buttons{
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: rgb(137, 137, 186);
        border: 1px solid rgb(137, 137, 186);
        color: #fff;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin-top: 15px;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
    }
    ul li{
        list-style: none;
    }
    .contents{
        padding: 20px;
        margin: 20px;
        background: #fff;
    }
    .border{
        border: 1px solid #DCDFE6;
        padding: 0 20px;
        margin-bottom: 10px;
    }
    .notice{
        height: 38px;
        overflow: hidden;
        padding-right: 80px;
        position: relative;
    }
    .notice.myMove{
        animation:mymove 1s ease-in forwards;
        -moz-animation:mymove 1s ease-in forwards; /* Firefox */
        -webkit-animation:mymove 1s ease-in forwards; /* Safari and Chrome */
        -o-animation:mymove 1s ease-in forwards; /* Opera */
    }
    .notice>.loading{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .notice>.loading i{
        font-size: 20px;
        line-height: 40px;
    }
    .notice>.more{
        position: absolute;
        right: 20px;
        top: 0;
        line-height: 40px;
        font-size: 14px;
    }
    .notice a{
        color: rgb(137, 137, 186);
    }
    .notice .noticeTab:nth-child(1) span{
        float: left;
        margin-right: 10px;
    }
    .notice .noticeTab:nth-child(2) span{
        float: right;
        margin-right: 10px;
    }
    .notice .titleMsg{
        display: inline-block;
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .notice>.noticeTab{
        width: 45%;
        line-height: 38px;
        height: 38px;
        overflow: hidden;
        text-align: left;
        font-size: 14px;
    }
    .notice>.noticeTab:nth-child(2){
        text-align: right
    }
    .notice .item .titles{
        max-width: calc(100% - 160px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .floatL{
        float: left;
    }
    .floatR{
        float: right;
    }
    .clearfix{
        overflow:hidden;
        _zoom:1;
    }
    .redColor{
        color: #f00;
    }
    .basicColor{
        color: rgb(137, 137, 186)
    }
    /* .el-carousel__container .el-carousel__arrow--left, .el-carousel__container .el-carousel__arrow--right{
        display: none
    } */
    .msgTab{
        min-height: 600px;
    }
    .warnTab{
        line-height: 36px;
        font-size: 14px;
        border-color:#d90808;
    }
    .statusTab{
        padding: 10px 0;
        margin-bottom: 12px;
        border-bottom: 1px solid #DCDFE6;
        font-size: 14px;
    }
    .storage{
        border: 0 none;
    }
    .statusTab .button, .warnTab .button{
        color:  #0066cc;
        cursor: pointer;
        margin-left: 10px;
    }
    .statusTab .button:hover, .warnTab .button:hover{
        text-decoration: underline;
    }
    .grid-content{
        border-radius: 4px;
        height: 240px;
    }
    .Tabs{
        color: #fff;
    }
    .Tabs .el-col:nth-child(1)>.grid-content{
        background-color: #90d472;
    }
    .Tabs .el-col:nth-child(2)>.grid-content{
        background-color: #f27979;
    }
    .Tabs .el-col:nth-child(3)>.grid-content{
        background-color: #81b8ea;
    }
    .grid-content>p.tip{
        line-height: 40px;
        width: 100%;
        text-align: left;
        text-indent: 20px;
    }
    .grid-content>p.tip i{
        font-size: 18px;
    }
    .grid-content>.field{
        height: calc(100% - 80px);
        padding: 20px;
        width: calc(100% - 40px);
        background: rgba(255,255,255,.2)
    }
    .grid-content>.field>p{
        line-height: 40px;
    }

    .forTwo{
        margin: 12px 0;
        font-size: 14px;
    }
    .forTwo>.el-col>.listPanel{
        line-height: 40px;
        text-align: left;
        /* border-bottom: 1px solid #e6e6e6; */
    }
    .forTwo>.el-col>.listTab{
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding: 10px 15px;
    }
    .forTwo>.el-col>.listTab>li{
        line-height: 40px;
    }
    .forTwo>.el-col>.picPanel{
         border: 1px solid #DCDFE6;
         border-radius: 4px;
         padding: 10px 15px;
    }
    .forTwo>.el-col>.picPanel p.pic{
        width: 120px;
        height: 120px;
        margin: 10px auto;
        border-radius: 50%;
        overflow: hidden;
        border: 3px solid #DCDFE6;
    }

    @keyframes mymove {
        from { opacity: 1; height:38px }
        to { opacity: 0; height: 0px}
    }
    @-moz-keyframes mymove {
        from { opacity: 1; height:38px }
        to { opacity: 0; height: 0px}
    }
    @-webkit-keyframes mymove {
        from { opacity: 1; height:38px }
        to { opacity: 0; height: 0px}
    }
    @-o-keyframes mymove {
        from { opacity: 1; height:38px }
        to { opacity: 0; height: 0px}
    }

    .guideEnd{
        padding-top: 40px;
    }
    .guideEnd p.text{
        line-height: 24px;;
    }
    .guideEnd p.user{
        line-height: 32px;
        font-weight: bold;
        color: #666;
    }
    .guideEnd .headPic{
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        margin: 10px auto;
        border: 1px solid #888;
    }

    /* 轮播 */
    .operateGuide{
        width: 90%;
        max-width: 1500px;
        min-width: 900px;
        margin: 50px auto;
    }
    .rechargeBtn{
        width: 150px;
        height: 60px;
        background: rgb(0,0,0,.2);
        position: absolute;
        left: 52%;
        top: 180px;
        cursor: pointer;
    }
    .operateGuide .cardTab img{
        width: 100%;
        height: 100%;
    }
    .el-carousel__container{
        height: 460px;
    }
    .contents .hasFinish{
        padding-top: 100px;
    }
    .hasFinish p{
        line-height: 60px;
    }
    .hasFinish p span.time{
        color: rgb(137, 137, 186);
        text-decoration: underline;
        cursor: pointer;
    }
    /* .violet, .violet:hover{
        background: rgb(137, 137, 186);
        color: rgb(255, 255, 255);
        outline: none;
    } */

    /* 组件样式 */
    .el-step__icon{
        width: 28px;
        height: 28px;
    }
    .el-step.is-center .el-step__line{
        left: 55%;
        right: -45%;
    }
    .el-step__head.is-success{
        color: rgb(137, 137, 186);
        border-color: rgb(137, 137, 186);
    }
    .el-step__title.is-success{
        color: rgb(137, 137, 186);
    }
    .el-step__head.is-success .el-step__icon.is-text{
        background: rgb(137, 137, 186);
        color: #FFF;
    }
    .isActive .el-step__title{
        color: rgb(137, 137, 186);
    }
    .el-input--prefix .el-input__inner{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/home/home.vue